import $ from "jquery";
import { addPersonSite } from "./addPersonSite";
import { application } from "../application/application";
import { dataaccess } from "../dataaccess/dataContext";
import { services } from "../services/notificationService";
import { forms } from "../framework/forms";

function init() {
    dataaccess.get({ url: "/Person/CanUserEdit/" + $("#personId").val() }).done(function(result) {
        if (result === true) {
            $("#add-role-window").show();
            $("#btnBasicInfoEdit").show();
        } else {
            $("#add-role-window").hide();
            $("#btnBasicInfoEdit").hide();
            $("#add-edition-window").hide();
        }
    });

    $("#deactivate-dropdown a").click(function() {
        const url = "/person/deactivate/" + $("#personId").val();
        dataaccess
            .post({ url: url })
            .done(function() {
                window.location.href =
                    application.baseUrl + "/person/index/" + $("#personId").val();
                services.notificationService.success("Successfully Deactivated");
            });
    });

    $("#activate-dropdown a").click(function() {
        const url = "/person/activate/" + $("#personId").val();
        dataaccess
            .post({ url: url })
            .done(function() {
                window.location.href =
                    application.baseUrl + "/person/index/" + $("#personId").val();
                services.notificationService.success("Successfully Activated");
            });
    });

    $(document).on("click", "#addPersonSitebtn", addPersonSite.btnSearchSitesClick);

    $("#programDdl").change(renderEthosBank);
    $("#editionDdl").change(renderEthosBank);

    renderEthosBank();

    $("#aPrintTrainingHistory").click(printCompleteTrainingHistory);

    $("#collapseExample").on("hidden.bs.collapse", function() {
        const element = $("#personal a[data-target='#collapseExample'] button i");
        element.removeClass("fa-minus").addClass("fa-plus");
    });

    $("#collapseExample").on("shown.bs.collapse", function() {
        const element = $("#personal a[data-target='#collapseExample'] button i");
        element.removeClass("fa-plus").addClass("fa-minus");
    });

    $(".rolecardprint").on("click", printCard);
}

function renderEthosBank() {
    const program = $("#programDdl").val();
    const edition = $("#editionDdl").val();

    if ($("#isSiteCoordinator").val() === "True" && program !== undefined && edition !== undefined) {
        dataaccess
            .get({
                url:
                    "/EthosBank/Person/" +
                    $("#personId").val() +
                    "/Program/" +
                    program +
                    "/CourseEdition/" +
                    edition
            })
            .done(function(result) {
                $("#ethosBankContainer").html(result);
            });
    }
}

function printCard() {
    const url = $(this).attr("printurl");
    forms.openPrintWindow(url);
}

function printCompleteTrainingHistory() {
    const url =
        "/Person/PrintCourseHistory/" +
        $("#personId").val();
    forms.openPrintWindow(url);
}

export const person = {
    init: init,
    renderEthosBank: renderEthosBank
};
